import {
	backgroundAfterOrderResume,
	backgroundApplyButtonOrderResume,
	backgroundBtnCVVSubscriber,
	backgroundBtnFowardFormButton,
	backgroundBtnLoadingBtnDisabledFormButton,
	backgroundFooterAssinatura,
	backgroundFormWrapper,
	backgroundHeader,
	backgroundHeaderMobile,
	backgroundLoading,
	backgroundNavActivePayment,
	backgroundNavAnchorPayment,
	backgroundNavPayment,
	backgroundOrderResume,
	backgroundSliderCheckedSubscriber,
	backgroundSliderSubscriber,
	backgroundWaitingDisabledButtonOrderResume,
	borderBtnAddSubscriberFormButton,
	borderBtnBackFormButton,
	borderH2OrderResume,
	borderTopLastChildTdOrderResume,
	boxShadowOrderResume,
	colorAnchorSubscriber,
	colorApplyButtonOrderResume,
	colorBorderSubscriber,
	colorBtnAddSubscriberBtnBackFormButton,
	colorBtnFowardFormButton,
	colorBtnLoadingBtnDisabledFormButton,
	colorErrorSubscriber,
	colorFilterIconSubscriber,
	colorFilterImgLoading,
	colorFormTermsSubscriber,
	colorH2H4AnchorIconContainerOrderResume,
	colorIconOrderResume,
	colorInputOrderResume,
	colorListSubscribers,
	colorListSubscribersFaRegEdit,
	colorListSubscribersFaTrashAlt,
	colorNavActivePayment,
	colorNavPayment,
	colorNavSvgActivePayment,
	colorNavSvgPayment,
	colorResumeCupomOrderResume,
	colorSmallOrderResume,
	colorSpanOrderResume,
	colorSubscriber,
	colorSvgApplyButtonOrderResume,
	colorSvgButtonOrderResume,
	colorTdOrderResume,
	colorTdSvgOrderResume,
	colorTextLoading,
	colorTimeLine,
	colorTimeLineBefore,
	colorTimeLineStatusBefore,
	colorTitleListSubscribers,
	colorTitlePayment,
	colorTitleSubscriber,
	colorValueOrderResume,
	colorWaitingDisabledButtonOrderResume,
	fontFamilyFooter,
	fontFamilyFormButton,
	fontFamilyListSubscribers,
	fontFamilyNavPayment,
	fontFamilyOrderResume,
	fontFamilyStrongTitleSubscriber,
	fontFamilySubscriber,
	fontFamilyTextLoading,
	fontFamilyTimeLine,
	fontFamilyTitleListSubscribers,
	fontFamilyTitlePayment,
	fontFamilyTitleSubscriber,
	fontWeightBtnFowardBtnBackFormButton,
	fontWeightFooter,
	fontWeightFormButton,
	fontWeightH2H4OrderResume,
	fontWeightH4Footer,
	fontWeightLabelSubscriber,
	fontWeightListSubscribers,
	fontWeightNavPayment,
	fontWeightSmallOrderResume,
	fontWeightSpanOrderResume,
	fontWeightStrongTitleSubscriber,
	fontWeightSubscriber,
	fontWeightTextLoading,
	fontWeightTimeLine,
	fontWeightTitleListSubscribers,
	fontWeightTitlePayment,
	fontWeightTitleSubscriber,
	textFooterAssinatura,
	textParagraphFooterAssinatura,
	textSpanTimeLine,
	backgroundCheckmarkFormCarrinho,
	backgroundContainerCheckboxHoverFormCarrinho,
	backgroundInstallmentFormCarrinho,
	backgroundInstallmentsFirstBoxFormCarrinho,
	backgroundInstallmentsSecondBoxFormCarrinho,
	backgroundInstallmentsThirdBoxFormCarrinho,
	backgroundTextInformationPlanHrFormCarrinho,
	borderCheckmarkAfterFormCarrinho,
	borderCheckmarkFormCarrinho,
	boxShadowInstallmentFormCarrinho,
	boxShadowInstallmentHoverFormCarrinho,
	colorBenefitsAdd2FormCarrinho,
	colorCheckoutItemsH3FormCarrinho,
	colorGraceTextFormCarrinho,
	colorInfoBlockDetailsFormCarrinho,
	colorInfoBlockH3FormCarrinho,
	colorInfoBlockParagraphFormCarrinho,
	colorInstallmentH2FormCarrinho,
	colorInstallmentPriceFormCarrinho,
	colorInstallmentTagPercentageFormCarrinho,
	colorInstallmentTextTotalFormCarrinho,
	colorTextInformationPlanTitleFormCarrinho,
	colorTextInstallmentFormCarrinho,
	fontFamilyBenefitsAdd2FormCarrinho,
	fontFamilyCheckoutItemsH3FormCarrinho,
	fontFamilyGraceTextFormCarrinho,
	fontFamilyInfoBlockDetailsFormCarrinho,
	fontFamilyInfoBlockH3FormCarrinho,
	fontFamilyInfoBlockParagraphFormCarrinho,
	fontFamilyInstallmentTagPercentageFormCarrinho,
	fontFamilyInstallmentTextTotalFormCarrinho,
	fontFamilyPlansH2FormCarrinho,
	fontFamilyTextInformationPlanTitleFormCarrinho,
	filterLogoHeader,
	colorBackgroundChecked
} from './variables';

export const demonstrationVivoTheme = {
	// Header
	backgroundHeaderMobile: backgroundHeaderMobile,
	backgroundHeader: backgroundHeader,
	filterLogoHeader: filterLogoHeader,

	// Footer
	backgroundFooter: backgroundFooterAssinatura,
	textFooter: textFooterAssinatura,
	textParagraphFooter: textParagraphFooterAssinatura,
	fontFamilyFooter: fontFamilyFooter,
	fontWeightFooter: fontWeightFooter,
	fontWeightH4Footer: fontWeightH4Footer,

	// StepCounter (progress bar)
	colorTimeLineBefore: colorTimeLineBefore,
	colorTimeLine: colorTimeLine,
	colorTimeLineStatusBefore: colorTimeLineStatusBefore,
	textSpanTimeLine: textSpanTimeLine,
	fontFamilyTimeLine: fontFamilyTimeLine,
	fontWeightTimeLine: fontWeightTimeLine,

	// Subscribers list Title
	colorTitleListSubscribers: colorTitleListSubscribers,
	fontFamilyTitleListSubscribers: fontFamilyTitleListSubscribers,
	fontWeightTitleListSubscribers: fontWeightTitleListSubscribers,

	// Subscribers list
	colorListSubscribers: colorListSubscribers,
	colorListSubscribersFaRegEdit: colorListSubscribersFaRegEdit,
	colorListSubscribersFaTrashAlt: colorListSubscribersFaTrashAlt,
	fontFamilyListSubscribers: fontFamilyListSubscribers,
	fontWeightListSubscribers: fontWeightListSubscribers,

	// Subscriber Title
	colorTitleSubscriber: colorTitleSubscriber,
	fontFamilyStrongTitleSubscriber: fontFamilyStrongTitleSubscriber,
	fontFamilyTitleSubscriber: fontFamilyTitleSubscriber,
	fontWeightTitleSubscriber: fontWeightTitleSubscriber,
	fontWeightStrongTitleSubscriber: fontWeightStrongTitleSubscriber,

	// Subscriber Form
	colorFilterIconSubscriber: colorFilterIconSubscriber,
	colorSubscriber: colorSubscriber,
	fontFamilySubscriber: fontFamilySubscriber,
	fontWeightLabelSubscriber: fontWeightLabelSubscriber,
	fontWeightSubscriber: fontWeightSubscriber,
	colorErrorSubscriber: colorErrorSubscriber,
	colorBorderSubscriber: colorBorderSubscriber,
	colorAnchorSubscriber: colorAnchorSubscriber,
	colorFormTermsSubscriber: colorFormTermsSubscriber,
	backgroundBtnCVVSubscriber: backgroundBtnCVVSubscriber,
	backgroundSliderCheckedSubscriber: backgroundSliderCheckedSubscriber,
	backgroundSliderSubscriber: backgroundSliderSubscriber,

	// Payment Title
	colorTitlePayment: colorTitlePayment,
	fontFamilyTitlePayment: fontFamilyTitlePayment,
	fontWeightTitlePayment: fontWeightTitlePayment,

	// Payment Nav-tab
	backgroundNavActivePayment: backgroundNavActivePayment,
	backgroundNavAnchorPayment: backgroundNavAnchorPayment,
	backgroundNavPayment: backgroundNavPayment,
	colorNavActivePayment: colorNavActivePayment,
	colorNavPayment: colorNavPayment,
	colorNavSvgActivePayment: colorNavSvgActivePayment,
	colorNavSvgPayment: colorNavSvgPayment,
	fontFamilyNavPayment: fontFamilyNavPayment,
	fontWeightNavPayment: fontWeightNavPayment,

	// Form Button
	backgroundBtnFowardFormButton: backgroundBtnFowardFormButton,
	backgroundBtnLoadingBtnDisabledFormButton: backgroundBtnLoadingBtnDisabledFormButton,
	borderBtnAddSubscriberFormButton: borderBtnAddSubscriberFormButton,
	borderBtnBackFormButton: borderBtnBackFormButton,
	colorBtnAddSubscriberBtnBackFormButton: colorBtnAddSubscriberBtnBackFormButton,
	colorBtnFowardFormButton: colorBtnFowardFormButton,
	colorBtnLoadingBtnDisabledFormButton: colorBtnLoadingBtnDisabledFormButton,
	fontFamilyFormButton: fontFamilyFormButton,
	fontWeightBtnFowardBtnBackFormButton: fontWeightBtnFowardBtnBackFormButton,
	fontWeightFormButton: fontWeightFormButton,
	colorBackgroundChecked: colorBackgroundChecked,

	// Order Resume
	backgroundApplyButtonOrderResume: backgroundApplyButtonOrderResume,
	backgroundWaitingDisabledButtonOrderResume: backgroundWaitingDisabledButtonOrderResume,
	colorApplyButtonOrderResume: colorApplyButtonOrderResume,
	colorH2H4AnchorIconContainerOrderResume: colorH2H4AnchorIconContainerOrderResume,
	colorIconOrderResume: colorIconOrderResume,
	colorInputOrderResume: colorInputOrderResume,
	colorSmallOrderResume: colorSmallOrderResume,
	colorSpanOrderResume: colorSpanOrderResume,
	colorSvgApplyButtonOrderResume: colorSvgApplyButtonOrderResume,
	colorSvgButtonOrderResume: colorSvgButtonOrderResume,
	colorTdOrderResume: colorTdOrderResume,
	colorValueOrderResume: colorValueOrderResume,
	colorWaitingDisabledButtonOrderResume: colorWaitingDisabledButtonOrderResume,
	fontFamilyOrderResume: fontFamilyOrderResume,
	fontWeightH2H4OrderResume: fontWeightH2H4OrderResume,
	fontWeightSmallOrderResume: fontWeightSmallOrderResume,
	fontWeightSpanOrderResume: fontWeightSpanOrderResume,
	colorTdSvgOrderResume: colorTdSvgOrderResume,
	backgroundOrderResume: backgroundOrderResume,
	borderH2OrderResume: borderH2OrderResume,
	borderTopLastChildTdOrderResume: borderTopLastChildTdOrderResume,
	backgroundAfterOrderResume: backgroundAfterOrderResume,
	boxShadowOrderResume: boxShadowOrderResume,
	colorResumeCupomOrderResume: colorResumeCupomOrderResume,

	// Loading
	backgroundLoading: backgroundLoading,
	colorFilterImgLoading: colorFilterImgLoading,
	colorTextLoading: colorTextLoading,
	fontFamilyTextLoading: fontFamilyTextLoading,
	fontWeightTextLoading: fontWeightTextLoading,

	// Form Wrapper
	backgroundFormWrapper: backgroundFormWrapper,

	// Form Carrinho
	backgroundCheckmarkFormCarrinho: backgroundCheckmarkFormCarrinho,
	backgroundContainerCheckboxHoverFormCarrinho: backgroundContainerCheckboxHoverFormCarrinho,
	backgroundInstallmentFormCarrinho: backgroundInstallmentFormCarrinho,
	backgroundInstallmentsFirstBoxFormCarrinho: backgroundInstallmentsFirstBoxFormCarrinho,
	backgroundInstallmentsSecondBoxFormCarrinho: backgroundInstallmentsSecondBoxFormCarrinho,
	backgroundInstallmentsThirdBoxFormCarrinho: backgroundInstallmentsThirdBoxFormCarrinho,
	backgroundTextInformationPlanHrFormCarrinho: backgroundTextInformationPlanHrFormCarrinho,
	borderCheckmarkAfterFormCarrinho: borderCheckmarkAfterFormCarrinho,
	borderCheckmarkFormCarrinho: borderCheckmarkFormCarrinho,
	boxShadowInstallmentFormCarrinho: boxShadowInstallmentFormCarrinho,
	boxShadowInstallmentHoverFormCarrinho: boxShadowInstallmentHoverFormCarrinho,
	colorBenefitsAdd2FormCarrinho: colorBenefitsAdd2FormCarrinho,
	colorCheckoutItemsH3FormCarrinho: colorCheckoutItemsH3FormCarrinho,
	colorGraceTextFormCarrinho: colorGraceTextFormCarrinho,
	colorInfoBlockDetailsFormCarrinho: colorInfoBlockDetailsFormCarrinho,
	colorInfoBlockH3FormCarrinho: colorInfoBlockH3FormCarrinho,
	colorInfoBlockParagraphFormCarrinho: colorInfoBlockParagraphFormCarrinho,
	colorInstallmentH2FormCarrinho: colorInstallmentH2FormCarrinho,
	colorInstallmentPriceFormCarrinho: colorInstallmentPriceFormCarrinho,
	colorInstallmentTagPercentageFormCarrinho: colorInstallmentTagPercentageFormCarrinho,
	colorInstallmentTextTotalFormCarrinho: colorInstallmentTextTotalFormCarrinho,
	colorTextInformationPlanTitleFormCarrinho: colorTextInformationPlanTitleFormCarrinho,
	colorTextInstallmentFormCarrinho: colorTextInstallmentFormCarrinho,
	fontFamilyBenefitsAdd2FormCarrinho: fontFamilyBenefitsAdd2FormCarrinho,
	fontFamilyCheckoutItemsH3FormCarrinho: fontFamilyCheckoutItemsH3FormCarrinho,
	fontFamilyGraceTextFormCarrinho: fontFamilyGraceTextFormCarrinho,
	fontFamilyInfoBlockDetailsFormCarrinho: fontFamilyInfoBlockDetailsFormCarrinho,
	fontFamilyInfoBlockH3FormCarrinho: fontFamilyInfoBlockH3FormCarrinho,
	fontFamilyInfoBlockParagraphFormCarrinho: fontFamilyInfoBlockParagraphFormCarrinho,
	fontFamilyInstallmentTagPercentageFormCarrinho: fontFamilyInstallmentTagPercentageFormCarrinho,
	fontFamilyInstallmentTextTotalFormCarrinho: fontFamilyInstallmentTextTotalFormCarrinho,
	fontFamilyPlansH2FormCarrinho: fontFamilyPlansH2FormCarrinho,
	fontFamilyTextInformationPlanTitleFormCarrinho: fontFamilyTextInformationPlanTitleFormCarrinho
};
